import React, { useEffect, useState } from "react";
import "./style.css";
const ProgressBar = (props) => {
    const [state, setState] = useState("0");
    const { icon, color, filledPct, animationDelay = 0 } = props;
    useEffect(() => {
        const timeout = setTimeout(() => {
            setState(filledPct + "%");
        }, animationDelay);
        return () => clearTimeout(timeout);
    }, []);
    return (React.createElement("div", { className: 'share-progressbar' },
        React.createElement("svg", { className: 'bi share-progressbar-icon', fill: 'currentColor', style: { color } },
            React.createElement("use", { xlinkHref: icon })),
        React.createElement("div", { className: 'share-progressbar-bar' },
            React.createElement("div", { className: 'share-progressbar-background' }),
            React.createElement("div", { className: 'share-progressbar-fill', style: {
                    background: color,
                    width: state,
                } }))));
};
export { ProgressBar };
